import React, { type ReactElement, type ReactNode } from "react";
import { Plus } from "lucide-react";
import { Button, cn } from "@ndd/ui";
import { AGENDA_PRIMARY_FILL, AGENDA_UTILITY_RADIUS } from "./agenda-look";

/**
 * What the Week view adds to the page: its panel, the header buttons and
 * their dialogs.
 */
export interface AppointmentWeekSlot {
  panel: ReactNode;
  busy: boolean;
  /** Opens the Block time dialog (NO-877); absent only while the action cannot run. */
  onBlockTime?: () => void;
  /** Opens New appointment (NO-912: from every tab); absent only while the action cannot run. */
  onNewAppointment?: () => void;
  /** The dialogs the header buttons open, mounted at page level so every tab has them. */
  dialogs?: ReactNode;
}

/** Block time (utility) and New appointment (press), top right beside the h1. */
export function WeekHeaderActions({
  week,
}: {
  week: AppointmentWeekSlot;
}): ReactElement {
  return (
    <div className="col-start-2 row-start-1 flex shrink-0 flex-wrap items-center gap-2 self-start justify-self-end pt-1 @max-[560px]:col-start-1 @max-[560px]:row-start-3 @max-[560px]:justify-self-start">
      <Button
        type="button"
        variant="utility"
        size="compact"
        className={cn("px-3.5 text-body-sm", AGENDA_UTILITY_RADIUS)}
        disabled={!week.onBlockTime}
        onClick={week.onBlockTime}
      >
        Block time
      </Button>
      <Button
        type="button"
        variant="press"
        size="compact"
        shape="pill"
        className={cn("px-[18px] text-body-sm", AGENDA_PRIMARY_FILL)}
        disabled={!week.onNewAppointment}
        onClick={week.onNewAppointment}
      >
        <Plus aria-hidden="true" strokeWidth={2.5} />
        New appointment
      </Button>
    </div>
  );
}
